import styled from '@emotion/styled';

const Container = styled.div`
  border: 2px solid white;
  border-radius: 5px;
  color: white;
  width: 250px;
  max-width: 100%;
  height: 200px;
  background-image: url('assets/images/fiscabox_back.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  transition:
    box-shadow 0.2s ease,
    transform 0.2s ease;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.35) 0%,
      rgba(0, 0, 0, 0.78) 68%,
      rgba(0, 0, 0, 0.9) 100%
    );
    width: 100%;
    height: 100%;

    > .head {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.2;
      margin-bottom: 12px;
      color: white;
    }

    > .content {
      color: rgba(255, 255, 255, 0.78);
      font-size: 14px;
      font-family: Poppins-L;
      line-height: 1.45;
    }
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
    cursor: pointer;
    transform: translateY(-2px);
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const FiscaBox = ({ title, body }: { title: string; body: string }) => {
  return (
    <Container>
      <div>
        <h2 className='head'>{title}</h2>
        <div className='content'>{body}</div>
      </div>
    </Container>
  );
};
